<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4pTgz4/tc-custom/9781488007729.jpg?1726871266014" alt="This image is the cover for the book Reclaiming His Past, Smoky Mountain Matches"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Reclaiming His Past, Smoky Mountain Matches
      </h1>
      <p class="bookDescription body article font2">
        <b>A desperate man without a past may find a future with a spirited young woman in this uplifting historical romance set in the Smokey Mountains.</b><br/><br/>The wounded stranger found on Jessica O’Malley’s property has no idea who he is. And Jessica would be foolish to trust him after being proven so wrong about a former suitor who turned out to be a criminal. But Jessica’s wariness toward the newcomer is soon turning to interest . . . and hope.<br/><br/>Until he knows his true identity, “Grant” can’t make a life in this quaint Tennessee town. He certainly shouldn’t be thinking so much about the feisty redhead with beautiful, guarded eyes. But even as he fights to keep a distance from Jessica, his feelings for her grow. And he can’t help but wonder if he’ll even want to return to his old life when his past is revealed.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Karen Kirst
      </h2>
      
      <p class="authorDescription body article">Karen Kirst was born and raised in East Tennessee near the Great Smoky Mountains.&#160;In the fall of 2010, she got the happy news that Harlequin Love Inspired Historical wanted to publish her manuscript-a true blessing from God. When that line closed, she switched to Love Inspired Suspense. Now she divides her time between being a wife, homeschooling mom, and romance writer.&#160; &#160;<BR />&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4c016ddc